export default {
    school: "学校管理",
    schoolDetail: "学校详情",
    studentDetail: "学生信息",
    teacherDetail: "老师信息",
    klassDetail: "班级信息",
    klassCircle: "班级圈",
    themeList: "主题列表",
    createTheme: "创建主题",
    updateTheme: "编辑主题",
    publish: "发布信息",
    album: "成长手册",
    albumDetail: "手册详情",
    albumTempDetail: "手册模板详情",
    sensitive: "敏感词",
    external: "资料分享",
    externalCreate: "新建分享资料",
    externalUpdate: "修改分享资料",
    userInfo: "个人信息",
    klassTask: "发展评估",
    assessmentList: "发展评估",
    assessment: "进行评估",
    archivedTask: "归档任务",
    archivedAssessmentList: "已归档评估"
}